import { Outlet } from 'react-router-dom';
import { AppBar, BottomNav } from '@/design/components';
import { OfflineBand } from '@/app/OfflineBand';
import { UpdateBand } from '@/app/UpdateBand';
import { DesktopAside } from './DesktopAside';

/**
 * אפליקציית העובד. נבנתה לטלפון (רוחב 375), וזו החלטה ולא מגרעת
 * (מסמך התכנון, עיקרון 4).
 *
 * במסך רחב היא מוצגת ממוסגרת בגודל שלה, לצד הסבר קצר, ולא נמתחת
 * ולא נשארת עמודה צרה באמצע מסך ריק. הסרגלים נשארים בתוך המסגרת,
 * כי סרגל תחתון שרוחבו מטר אינו ניווט אלא פס.
 */
export function EmployeeLayout() {
  return (
    <div className="lg:grid lg:min-h-dvh lg:items-center lg:justify-center lg:gap-10 lg:bg-olive-soft lg:p-10 lg:[grid-template-columns:auto_auto]">
      <div className="grid min-h-dvh grid-rows-[auto_auto_1fr_auto] bg-cream lg:h-[min(46rem,calc(100dvh-5rem))] lg:w-[23.5rem] lg:min-h-0 lg:overflow-hidden lg:rounded-lg lg:shadow-card">
        <AppBar />
        <div>
          <OfflineBand />
          <UpdateBand />
        </div>
        {/* min-h-0 כדי שהשורה תוכל להתכווץ, אחרת אין מה לגלול בתוכה */}
        <main className="mx-auto w-full min-w-0 max-w-screen-sm lg:min-h-0 lg:overflow-y-auto">
          <Outlet />
        </main>
        <BottomNav />
      </div>

      {/* אחרי האפליקציה במבנה: ב RTL היא בימין, וההסבר משני לה */}
      <DesktopAside />
    </div>
  );
}
